import { canAccessCredoraPath } from "../../constants/menuAccess";
import { hasAnyPermission } from "../../constants/credoraRoles";

const pub = process.env.PUBLIC_URL || "";

/** Quick-create entries for the header +NEW menu. */
export const HEADER_QUICK_CREATE_ACTIONS = [
  {
    id: "loan-group",
    label: "Group loan",
    type: "navigate",
    path: `${pub}/credora/loans/new/group`,
  },
  {
    id: "loan",
    label: "Loan",
    type: "navigate",
    path: `${pub}/credora/loans/new`,
  },
  {
    id: "borrower",
    label: "Borrower",
    type: "modal",
    modal: "borrower",
    permissions: ["borrowers.create"],
  },
  {
    id: "guarantor",
    label: "Guarantor",
    type: "modal",
    modal: "guarantor",
    permissions: ["borrowers.read"],
  },
  {
    id: "collateral",
    label: "Collateral",
    type: "modal",
    modal: "collateral",
    permissions: ["borrowers.manage"],
  },
  {
    id: "collection",
    label: "Collection",
    type: "navigate",
    path: `${pub}/credora/collections`,
  },
  {
    id: "restructuring",
    label: "Restructuring",
    type: "modal",
    modal: "restructuring",
    permissions: ["loans.manage"],
  },
  {
    id: "ptp",
    label: "Promise to pay",
    type: "navigate",
    path: `${pub}/credora/collections/ptp`,
  },
];

function canUseQuickCreateAction(user, action) {
  if (action.permissions?.length) {
    return hasAnyPermission(user, action.permissions);
  }
  if (action.path) {
    return canAccessCredoraPath(user, action.path);
  }
  return false;
}

export function visibleQuickCreateActions(user) {
  return HEADER_QUICK_CREATE_ACTIONS.filter((action) => canUseQuickCreateAction(user, action));
}
